export default __webpack_public_path__ + "static/media/rules_income-bg.55c2326b.jpg";